'use client'

import dynamic from 'next/dynamic'

import { Loading } from '../../../loading'

export const DynamicProductSellerPromotionDialogContent = dynamic(
  async () =>
    import('./ProductSellerPromotionDialogContent').then(
      (mod) => mod.ProductSellerPromotionDialogContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)
